// frontend/src/components/employee/availability/AvailabilityModal.js

import React, { useMemo, useState } from "react";
import { buildTimeOptions, fmtTimeLabel } from "./availabilityUtils";

export default function AvailabilityModal({
  open,
  onClose,
  date,
  initialStartMin = 9 * 60,
  initialEndMin = 17 * 60,
  onSave,
  onDelete,
  mode = "create", // "create" | "edit"
}) {
  const options = useMemo(() => buildTimeOptions(), []);
  const [startMin, setStartMin] = useState(initialStartMin);
  const [endMin, setEndMin] = useState(initialEndMin);

  // Fix: Extract time to a stable variable for the dependency array
  const dateTimestamp = date?.getTime();

  // reset when opened / date changes
  React.useEffect(() => {
    if (!open) return;
    setStartMin(initialStartMin);
    setEndMin(initialEndMin);
  }, [open, initialStartMin, initialEndMin, dateTimestamp]);

  if (!open || !date) return null;

  const canSave = endMin > startMin;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
        padding: 16,
      }}
      onMouseDown={onClose}
    >
      <div
        style={{
          width: "min(520px, 100%)",
          background: "#fff",
          borderRadius: 18,
          border: "1px solid #e5e7eb",
          boxShadow: "0 24px 80px rgba(15,23,42,0.35)",
          overflow: "hidden",
        }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div style={{ padding: 16, borderBottom: "1px solid #eef2f7" }}>
          <div style={{ fontWeight: 950, color: "#0f172a", fontSize: 16 }}>
            {mode === "edit" ? "Edit Availability" : "Add Availability"}
          </div>
          <div style={{ marginTop: 6, fontWeight: 900, color: "#64748b", fontSize: 12 }}>
            {date.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
          </div>
        </div>

        <div style={{ padding: 16, display: "grid", gap: 14 }}>
          <div>
            <div style={{ fontWeight: 950, fontSize: 12, color: "#0f172a", marginBottom: 6 }}>Start Time</div>
              <select
              value={startMin}
              onChange={(e) => setStartMin(parseInt(e.target.value, 10))}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 12,
                border: "1px solid #e2e8f0",
                fontWeight: 900,
              }}
            >
              {options.slice(0, -1).map((minute) => (
                <option key={minute} value={minute}>
                  {fmtTimeLabel(minute)}
                </option>
              ))}
            </select>
          </div>

          <div>
            <div style={{ fontWeight: 950, fontSize: 12, color: "#0f172a", marginBottom: 6 }}>End Time</div>
              <select
              value={endMin}
              onChange={(e) => setEndMin(parseInt(e.target.value, 10))}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 12,
                border: "1px solid #e2e8f0",
                fontWeight: 900,
              }}
            >
              {options.slice(1).map((minute) => (
                <option key={minute} value={minute}>
                  {fmtTimeLabel(minute)}
                </option>
              ))}
            </select>

            {!canSave ? (
              <div style={{ marginTop: 8, fontSize: 12, fontWeight: 900, color: "#b91c1c" }}>
                End time must be after start time.
              </div>
            ) : null}
          </div>
        </div>

        <div
          style={{
            padding: 16,
            borderTop: "1px solid #eef2f7",
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              background: "#fff",
              fontWeight: 950,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <div style={{ display: "flex", gap: 10 }}>
            {mode === "edit" ? (
              <button
                onClick={onDelete}
                style={{
                  padding: "10px 14px",
                  borderRadius: 12,
                  border: "1px solid #fecaca",
                  background: "#fff",
                  color: "#b91c1c",
                  fontWeight: 950,
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            ) : null}

            <button
              onClick={() => onSave({ startMin, endMin })}
              disabled={!canSave}
              style={{
                padding: "10px 14px",
                borderRadius: 12,
                border: "1px solid #1d4ed8",
                background: canSave ? "#2563eb" : "#93c5fd",
                color: "#fff",
                fontWeight: 950,
                cursor: canSave ? "pointer" : "not-allowed",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
